export default {
  mfname: '授权合作厂商名录',
  mfmission:
    '我们与以下全部厂商建立了长期深度合作关系，具备完善合作背书。本名录是工厂实地考察、合作方筛选的核心依据，充分彰显我方稳定可靠的供应链实力。',
  mf_categoryList: [
    {
      category: '空调类',
      manufacturers: ['英维克', '海悟', '克莱门特', '科士达'],
    },
    {
      category: '板式换热器类',
      manufacturers: ['艾普尔', '传特', '丹佛斯'],
    },
    {
      category: '冷却塔类',
      manufacturers: ['马利', '巴尔的摩', '埃米格'],
    },
    {
      category: '水泵类',
      manufacturers: ['威乐', '赛莱默', '格兰富', '荏原'],
    },
    {
      category: '冷水机组类',
      manufacturers: ['约克', '特灵', '开利', '麦克维尔'],
    },
    {
      category: '冷却分配单元CDU类',
      manufacturers: ['英维克', '曙光', '高澜'],
    },
    {
      category: '水处理类',
      manufacturers: ['栗田', '纳尔科', '捷宇通'],
    },
    {
      category: '楼宇自控BA系统类',
      manufacturers: ['江森自控', '西门子'],
    },
    {
      category: '变压器类',
      manufacturers: ['金盘', '大全', '特变电工'],
    },
    {
      category: '配电柜类',
      manufacturers: ['ABB', '施耐德电气', '伊顿', '西门子'],
    },
    {
      category: '电源分配单元PDU类',
      manufacturers: ['罗格朗', '克雷莫', '伊顿', 'TOP'],
    },
    {
      category: '不间断电源UPS类',
      manufacturers: ['施耐德电气', '伊顿', '台达'],
    },
    {
      category: '蓄电池类',
      manufacturers: ['南都', '双登', '理士', '圣阳', '西恩迪'],
    },
    {
      category: '母线槽类',
      manufacturers: ['施耐德电气', 'ABB', '西门子', '伊顿'],
    },
    {
      category: '柴油发电机组类',
      manufacturers: ['卡特彼勒', '康明斯', 'MTU', '盘古', '玉柴', '潍柴'],
    },
    {
      category: '动环监控类',
      manufacturers: ['英泽天成', '深圳中电'],
    },
  ],
};
